/**
 * Formatea una cantidad (material, partida, etc.) en es-ES natural, sin ceros
 * de relleno, con un máximo de 2 decimales. Devuelve '' para vacío/no numérico.
 *   0.5  -> "0,5"   |  0.25 -> "0,25"  |  3 -> "3"
 */
export const formatQuantity = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === '') return '';
  const n =
    typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
  if (!Number.isFinite(n)) return '';
  return n.toLocaleString('es-ES', { maximumFractionDigits: 2 });
};

/**
 * Normaliza lo tecleado en un input de decimal a un string-con-punto apto para
 * Number()/parseFloat: coma->punto, solo dígitos + un punto, recorta a maxDecimals.
 * Permite estados intermedios mientras se teclea ('', '0', '0.').
 */
export const normalizeDecimalInput = (raw: string, maxDecimals = 2): string => {
  if (raw == null) return '';
  let v = String(raw)
    .replace(',', '.')
    .replace(/[^\d.]/g, '');
  const firstDot = v.indexOf('.');
  if (firstDot !== -1) {
    // colapsa puntos extra: conserva el primero
    v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
    const [int, dec] = v.split('.');
    v = `${int}.${dec.slice(0, maxDecimals)}`;
  }
  return v;
};
